import React, {PropTypes} from 'react';
import CapacitySquadList from "./CapacitySquadList.jsx";
import CapacityAvailabilityModal from './CapacityAvailabilityModal.jsx';
import ErrorListContainer from 'shared/error/ErrorListContainer.jsx';

const Capacity = ( {
  squads,
  onUpdateClick,
  modalTitle,
  modalVisible,
  loadingSquads,
  onModalCloseClick,
  onSquadCapacityBlur,
  onSquadCapacityChange,
  onSquadVisibilityChange
}) => (

  <div className="flex center animated fadeIn">
    <div className="col-xs-12 col-lg-10">
      { 
        loadingSquads
        ? <div className="alert alert-info">{'Loading capacity data.'}</div>
        : squads.length
          ? <div>
            <div className="text-right">
              <button
                className="btn btn-primary btn-lg"
                disabled={!squads.length}
                onClick={onUpdateClick}
              >{`Bulk Update`}</button>
            </div>
            <br />
            <div className="row">
              <ErrorListContainer />
                <CapacitySquadList
                  squads={squads}
                  onSquadCapacityBlur={onSquadCapacityBlur}
                  onSquadCapacityChange={onSquadCapacityChange}
                  onSquadVisibilityChange={onSquadVisibilityChange}
                />
            </div>
            </div>
          : <div className="alert alert-info">{`No information to display.`}</div>
      }
    </div>
    <CapacityAvailabilityModal
      title={modalTitle}
      visible={modalVisible}
      onCloseClick={onModalCloseClick}
    />
  </div>
);

Capacity.propTypes = {
  squads: PropTypes.arrayOf(PropTypes.object),
  onUpdateClick: PropTypes.func,
  modalTitle: PropTypes.string,
  modalVisible: PropTypes.bool,
  loadingSquads: PropTypes.bool,
  onModalCloseClick: PropTypes.func,
  onSquadCapacityBlur: PropTypes.func,
  onSquadCapacityChange: PropTypes.func,
  onSquadVisibilityChange: PropTypes.func
};

Capacity.defaultProps = {
  squads: [],
  loadingSquads: true
};

export default Capacity;



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/Capacity.jsx